import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Collapse,
  Nav,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

import "./menu.scss";
import { useAuthUser } from "../../features/auth/authHooks";

type MenuProps = {
  isNarrow: boolean;
};

function Menu({ isNarrow }: MenuProps) {
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const { isOwnerUser } = useAuthUser();
  return (
    <>
      <Nav className="sidebar-menu bg-white flex-column" as="ul">
        {isOwnerUser && (
          <Nav.Item as="li">
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="tooltip-home">Etusivu</Tooltip>}
              show={isNarrow ? undefined : false}
            >
              <Nav.Link
                as={Link}
                to={"/"}
                className="d-flex flex-fill align-items-center"
              >
                <span className="bi bi-house-door"></span>
                <span className="txt">Etusivu</span>
              </Nav.Link>
            </OverlayTrigger>
          </Nav.Item>
        )}
        {!isOwnerUser && (
          <Nav.Item as="li">
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="tooltip-home">Varauskalenteri</Tooltip>}
              show={isNarrow ? undefined : false}
            >
              <Nav.Link
                as={Link}
                to={"/bookings"}
                className="d-flex flex-fill align-items-center"
              >
                <span className="bi bi-calendar2-week"></span>
                <span className="txt">Varauskalenteri</span>
              </Nav.Link>
            </OverlayTrigger>
          </Nav.Item>
        )}
        <Nav.Item as="li">
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id="tooltip-home">Tulijat ja lähtijät</Tooltip>}
            show={isNarrow ? undefined : false}
          >
            <Nav.Link
              as={Link}
              to={"/home-caretakers"}
              className="d-flex flex-fill align-items-center"
            >
              <span className="bi bi-arrow-left-right"></span>
              <span className="txt">Tulijat ja lähtijät</span>
            </Nav.Link>
          </OverlayTrigger>
        </Nav.Item>
        <Nav.Item as="li">
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id="tooltip-home">Kohteet</Tooltip>}
            show={isNarrow ? undefined : false}
          >
            <Nav.Link
              as={Link}
              to={"/accommodations"}
              className="d-flex flex-fill align-items-center"
            >
              <span className="bi bi-gear"></span>
              <span className="txt">Kohteet</span>
            </Nav.Link>
          </OverlayTrigger>
        </Nav.Item>

        {isOwnerUser && (
          <Nav.Item as="li">
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="tooltip-home">Hinnoittelu</Tooltip>}
              show={isNarrow ? undefined : false}
            >
              <Nav.Link
                as={Link}
                to={"/pricing"}
                className="d-flex align-items-center"
              >
                <span className="bi bi-currency-euro"></span>
                <span className="txt">Hinnoittelu</span>
              </Nav.Link>
            </OverlayTrigger>
          </Nav.Item>
        )}
        {isOwnerUser && (
          <Nav.Item as="li">
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="tooltip-ical">iCal</Tooltip>}
              show={isNarrow ? undefined : false}
            >
              <Nav.Link
                as={Link}
                to={"/ical-integrations"}
                className="d-flex align-items-center"
              >
                <span className="bi bi-calendar3"></span>
                <span className="txt">iCal</span>
              </Nav.Link>
            </OverlayTrigger>
          </Nav.Item>
        )}
        <Nav.Item as="li">
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id="tooltip-home">Palautteet</Tooltip>}
            show={isNarrow ? undefined : false}
          >
            <Nav.Link
              as={Link}
              to={"/feedbacks"}
              className="d-flex align-items-center"
            >
              <span className="bi bi-send"></span>
              <span className="txt">Palautteet</span>
            </Nav.Link>
          </OverlayTrigger>
        </Nav.Item>
        {isOwnerUser && (
          <Nav.Item as="li">
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="tooltip-home">Tilitysraportti</Tooltip>}
              show={isNarrow ? undefined : false}
            >
              <Nav.Link
                as={Link}
                to={"/reports/settlementReport"}
                className="d-flex align-items-center"
              >
                <span className="bi bi-graph-up-arrow"></span>
                <span className="txt">Tilitysraportti</span>
              </Nav.Link>
            </OverlayTrigger>
          </Nav.Item>
        )}
        <Nav.Item as="li">
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip id="tooltip-home">Ohjeet ja vinkit</Tooltip>}
            show={isNarrow ? undefined : false}
          >
            <Nav.Link
              as={Link}
              to={"/support"}
              className="d-flex align-items-center"
            >
              <span className="bi bi-question-lg"></span>
              <span className="txt">Ohjeet ja vinkit</span>
            </Nav.Link>
          </OverlayTrigger>
        </Nav.Item>
      </Nav>
    </>
  );
}

export default Menu;
